import * as React from "react";
import { Provider } from "mobx-react";
import { LIB_INSTANCES } from "../lib/index";

export class FpProvider extends React.Component<{}, {}> {
	public render() {
		return <Provider {...LIB_INSTANCES}>{this.props.children}</Provider>;
	}
}



// WEBPACK FOOTER //
// ./src/common/FpProvider.tsx